// src/store/draft/actions/actionTypes.js

export const GET_DRAFT_PACKAGES         = "GET_DRAFT_PACKAGES";
export const ADD_DRAFT_PACKAGE          = "ADD_DRAFT_PACKAGE";
export const UPDATE_DRAFT_PACKAGE       = "UPDATE_DRAFT_PACKAGE";
export const DELETE_DRAFT_PACKAGE       = "DELETE_DRAFT_PACKAGE";

export const INITIATE_DRAFT_REGISTRATION  = "INITIATE_DRAFT_REGISTRATION";
export const GET_DRAFT_REGISTRATIONS      = "GET_DRAFT_REGISTRATIONS";
export const GET_MY_DRAFT_REGISTRATIONS   = "GET_MY_DRAFT_REGISTRATIONS";
export const REQUEST_DRAFT_CANCELLATION   = "REQUEST_DRAFT_CANCELLATION";
export const GET_PENDING_CANCELLATIONS    = "GET_PENDING_CANCELLATIONS";
export const UPDATE_PLAYER_RATING         = "UPDATE_PLAYER_RATING";

export const SET_DRAFT_LOADING          = "SET_DRAFT_LOADING";
export const CLEAR_CHECKOUT_URL         = "CLEAR_CHECKOUT_URL";
